var bookshelf = require("../index-extended");
require("./BuildingOwnerVotingRight");
require("./BuildingLot");

module.exports = bookshelf.model("BuildingOwnerBuildingLot", {
  entityName: "BuildingOwnerBuildingLot",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "building_owner_building_lot",
  building_owner_voting_rights() {
    return this.hasMany("BuildingOwnerVotingRight", "building_owner_has_building_lot_id");
  },
  building_lot() {
    return this.belongsTo("BuildingLot");
  },

  format(attrs) {
    delete attrs["$id"];
    delete attrs["building_owner_voting_rights"];

    return attrs;
  },
});
